import { Button, Col, DatePicker, Form, Image, Modal, Row, Select, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";
import notfound from "../../assets/images/not_found.png";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import EditIcon from "../../assets/images/edit.svg";
import AddNotificationModal from "./_AddNotificationModal";
import lang from "../../helper/langHelper";
import ViewNotificationModal from "./_ViewNotificationModal";
// import AdvertisementBannerForm from "./AdvertisementBannerForm";

const { confirm } = Modal;

const PushNotificationManager = ({ sectionName }) => {
  const [pagination, setPagination] = useState({
    current: 1,
    total: 10,
  });

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [selectedAddBanner, setSelectedAddBanner] = useState();
  const [visible, setVisible] = useState(false);
  const [scheduleVisible, setScheduleVisible] = useState(false);
  const [schedulerTableVisible, setSchedulerTableVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [ sendingType,SetSendingType] = useState("create")

  const { request } = useRequest();

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
      console.log(query);
    }
    fetchData(pagination, filters, query);
  };

  const onDelete = (record) => {
    request({
      url: apiPath.notification + "/push/" + record?._id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchData = (sorter) => {
    request({
      url:
        `${apiPath.notification}/push` +
        `?status=${""}&page=${pagination ? pagination.current : 1}&pageSize=${
          pagination && pagination?.total ? pagination?.total : 10
        }&search=${""}`,
      method: "GET",
      onSuccess: (data) => {
        setList(data.data);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const columns = [

    {
      title: lang("Title"),
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => title,
    },
    {
      title: lang("notification type"),
      dataIndex: "notification_type",
      key: "notification_type",
      sorter: (a, b) => a?.notification_type?.localeCompare(b?.notification_type),
      sortDirections: ["ascend", "descend"],
      render: (_, { notification_type }) => notification_type,
    },  
    {
      title: lang("Notifications"),
      dataIndex: "message",
      key: "message",
      sorter: (a, b) => a?.message?.localeCompare(b?.message),
      sortDirections: ["ascend", "descend"],
      render: (_, { message }) => message,
    },   
  
   
   
    {
      title: lang("Action"),
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
           
              <>
              <Tooltip title={"View Notification"} color={"purple"} key={"View Notification"}>
                  <Button
                    title="View"
                    className="edit-cls btnStyle primary_btn"
                    onClick={() => {
                      setSelectedAddBanner(record);
                      setSchedulerTableVisible(true);
                    }}
                  >
                     <i class="far fa-eye"></i>
                  </Button>
                </Tooltip>
                   <Tooltip title={"Schedule Notification"} color={"purple"} key={"Schedule Notification"}>
                  <Button
                    title="Schedule"
                    className="edit-cls btnStyle primary_btn"
                    onClick={() => {
                      setSelectedAddBanner(record);
                      setScheduleVisible(true);
                    }}
                  >
               <i class="fas fa-calendar-alt"></i>
                  </Button>
                </Tooltip>
                <Tooltip title={"Edit"} color={"purple"} key={"Edit"}>
                  <Button
                    title="Edit"
                    className="edit-cls btnStyle primary_btn"
                    onClick={() => {
                      setSelectedAddBanner(record);
                      setVisible(true);
                    }}
                  >
                    <img src={EditIcon} />
                  </Button>
                </Tooltip>
                <Tooltip title={lang("Delete")} color={"purple"} key={lang("Delete")}>
              <Button
                title={lang("Delete")}
                className="btnStyle deleteDangerbtn"
                onClick={(e) => {
                  setSelectedAddBanner(record);
                  setShowDelete(true);
                }}
              >
                <img src={deleteWhiteIcon} />
              </Button>
            </Tooltip>
              </>
        
         
          </div>
        );
      },
    },
 
  ];

  useEffect(() => {
    fetchData(pagination);
  }, [refresh]);

  return (
    <>
      <SectionWrapper
        cardHeading={lang("Push Notifications")}
        extra={
          <>
            <div className="w-100 text-head_right_cont">
              <Button
                className="primary_btn btnStyle"
                onClick={(e) => {
                  setVisible(true);
                }}
              >
                <span className="add-Ic">
                  <img src={Plus} />
                </span>
                {lang("Add Notification")}
              </Button>
            </div>
          </>
        }
      >
        <div className="table-responsive customPagination">
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              defaultPageSize: 10,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>

      {visible && (
        <AddNotificationModal
          type={sectionName}
          sectionName={sectionName}
          show={visible}
          hide={() => {
            setSelectedAddBanner();
            setVisible(false);
            SetSendingType()

          }}
          ant-btn-default
          data={selectedAddBanner}
          sendingType={sendingType}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
     {scheduleVisible && (
        <ScheduleNotificationModal
          type={sectionName}
          sectionName={sectionName}
          show={scheduleVisible}
          hide={() => {
            setSelectedAddBanner();
            setScheduleVisible(false);
          }}
          ant-btn-default
          data={selectedAddBanner}
        
          refresh={() => setRefresh((prev) => !prev)}
        />
        )}

     {schedulerTableVisible && (
        <ViewNotificationModal
          type={sectionName}
          sectionName={sectionName}
          show={schedulerTableVisible}
          hide={() => {
            setSelectedAddBanner();
            setSchedulerTableVisible(false);
          }}
          ant-btn-default
          data={selectedAddBanner}
        
          refresh={() => setRefresh((prev) => !prev)}
        />
        )}
      {showDelete && (
        <DeleteModal
          title={lang("Delete Notification")}
          subtitle={lang(`Are you sure you want to Delete this notification?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelectedAddBanner();
          }}
          onOk={() => onDelete(selectedAddBanner)}
        />
      )}

    </>
  );
};




const targetAudience = [
  { name: "All", label: lang("All") },
  { name: "Selected", label: lang("Selected") },
];

const ScheduleNotificationModal = ({
  show,
  hide,
  data,
  refresh,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [selectAudience, setSelectAudience] = useState();
  const [users, setUsers] = useState([]);

  const onCreate = (values) => {
    const payload = {
      ...values,
    };

    if (data) payload.notification_id = data?._id;
    console.log(payload, "payload");

    setLoading(true);

    request({
      url: `${apiPath.notification}/add-scheduer`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getCustomer = () => {
    request({
      url: apiPath.common.allCustomer,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setUsers(data ?? []);
        }
        console.log(data, "data");
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  useEffect(() => {
    getCustomer();
    if (!!data) {
      form.setFieldsValue({
        ...data,
        users : data?.users?.map((itm)=> itm?.user_id),
        schedule_time: data.schedule_time ? moment(data.schedule_time) : "",
      });
      setSelectAudience(data.audience);

    }
  }, []);

  return (
    <Modal
      width={750}
      open={show}
      maskClosable={false}
      okText={lang("Add")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      className="tab_modal"
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <h4 className="modal_title_cls">
          Schedule Notification
        </h4>
        <Row gutter={[16, 0]} className="w-100">
          <Col span={24} sm={24} md={12}>
            <Form.Item
              name="audience"
              label={lang("Select Audience")}
              rules={[
                {
                  required: true,
                  message: lang("Please Select Audience"),
                },
              ]}
            >
              <Select
                onChange={(value) => setSelectAudience(value)}
                placeholder={lang("Select Audience")}
                className="w-100"
              >
                {targetAudience.map((item, index) => (
                  <option key={item.name} value={item.name}>
                    <span className="cap">{item.label}</span>
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12} sm={12} md={12}>
            <Form.Item
              name="schedule_time"
              label="Schedule Time"
              rules={[
                {
                  required: true,
                  message: "Please enter Schedule time",
                },
              ]}
            >
              <DatePicker
                placeholder="Enter Date & Time"
                format={"DD:MM:yy hh:mm a"}
                showTime={{ format: "hh:mm a" }}
              />
            </Form.Item>
          </Col>
          {selectAudience === "Selected" && (
            <Col span={24} md={24}>
              <Form.Item
                label={<> {"Customer Name"}</>}
                name="users"
                rules={[
                  {
                    required: true,
                    message: "Please select the Customer!",
                  },
                ]}
              >
                <Select

                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                  }
                  showSearch
                  placeholder={"Select Customer"}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  mode="multiple"
                >
                  {users?.map((item) => (
                    <Select.Option
                      key={item._id}
                      label={item.name}
                      value={item._id}
                    >
                      {item?.name ? item?.name : item?.email}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};




export default PushNotificationManager;
